import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Container } from '../container';
import { User } from '../user';

@Component({
  templateUrl: './deep-link.component.html',
  styleUrls: ['./deep-link.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class DeepLinkComponent implements OnInit {
  containers: Container[] = [];
  form: UntypedFormGroup;
  launchId = '';
  user: User | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
  ) {
    const titleService = inject(Title);
    const pageTitle = 'Deep Link - Noteable';
    titleService.setTitle(pageTitle);

    const myH1 = document.querySelector('h1');
    if (myH1) {
      myH1.textContent = pageTitle;
    }
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      select: '',
    });

    this.route.data.subscribe((data: { user: User; containers: Container[] }) => {
      this.user = data.user;
      this.containers = [...data.containers].sort((x1, x2) => x1.display_name.localeCompare(x2.display_name));
      this.form.patchValue({
        select: this.getDefaultContainer()?.id.toString() ?? '',
      });
    });

    this.launchId = this.route.snapshot.paramMap.get('launchId') ?? '';
  }

  configure() {
    window.location.href = this.getConfigurationUrl();
  }

  getConfigurationUrl(): string {
    const selectedContainerId = this.form.get('select')?.value ?? '';
    return `/lti1p3/configure/${encodeURIComponent(this.launchId)}/?container_id=${encodeURIComponent(selectedContainerId)}`;
  }

  private getDefaultContainer(): Container | undefined {
    const selectedNotebook = this.user?.notebook;
    return (
      this.containers.find(c => c.container_name === selectedNotebook || c.display_name === selectedNotebook) ||
      this.containers.find(c => c.display_name === 'Standard Notebook (Python 3)') ||
      this.containers[0]
    );
  }
}
